export default __webpack_public_path__ + "static/news-cf9284bd4520e1c50ef69f6540ddaaf1.svg";